// The decisions of the global search box (controllers/global_search_controller.js)
// as pure functions, tested without a browser
// (test/javascript/global_search_logic.test.mjs, `yarn test`).

export { moveIndex, suggestUrl } from "./combobox_logic.js"

// At least this many characters before the type-ahead asks (Crm::GlobalSearch::MIN_LENGTH).
export const MIN_LENGTH = 2

// What a key does in the search field, or null to let the browser have it
// (Enter with nothing highlighted submits the form to /search).
//   state: { open, active, count }
export function keyAction(key, { open, active, count }) {
  switch (key) {
    case "ArrowDown": return open ? "next" : (count > 0 ? "open" : null)
    case "ArrowUp": return open ? "prev" : (count > 0 ? "open" : null)
    case "Enter": return open && active >= 0 ? "go" : null
    case "Escape": return open ? "close" : "blur"
    case "Tab": return open ? "dismiss" : null
    default: return null
  }
}

// Whether "/" outside a field should focus the search box: no modifier and
// not typed into an input, a text area, a select or editable text.
export function isShortcut({ key, ctrlKey, metaKey, altKey, tagName, isContentEditable }) {
  if (key !== "/" || ctrlKey || metaKey || altKey || isContentEditable) return false
  return !["INPUT", "TEXTAREA", "SELECT"].includes(String(tagName || "").toUpperCase())
}

// Whether a text is long enough to ask for suggestions: two characters, or
// any number (a workspace id may be one digit), as Crm::GlobalSearch#searchable?.
export function searchable(query) {
  const text = query.trim()
  return text.length >= MIN_LENGTH || /^\d+$/.test(text)
}

// The suggestion answer as the list's rows: a heading per group, its hits as
// options, then one option for every result on the search page. Options
// are numbered in order (index), headings are not.
//   answer: { url, groups: [{ key, label, all_url, hits: [{ title, detail, url }] }] }
export function rows(answer) {
  const list = []
  let index = 0
  for (const group of answer.groups || []) {
    if (!group.hits || group.hits.length === 0) continue
    list.push({ heading: true, key: group.key, label: group.label, url: group.all_url })
    for (const hit of group.hits) {
      list.push({ heading: false, group: group.key, index: index++, title: hit.title, detail: hit.detail || "", url: hit.url })
    }
  }
  if (answer.url) list.push({ heading: false, group: "all", index: index++, title: "Všetky výsledky", detail: "", url: answer.url })
  return list
}

// The options of the rows (what the arrows move through).
export function options(list) {
  return list.filter((row) => !row.heading)
}

// "Nič sa nenašlo", "1 výsledok", "3 výsledky", "7 výsledkov": what the live region says (the "all" row not counted).
export function countMessage(count) {
  if (count === 0) return "Nič sa nenašlo"
  if (count === 1) return "1 výsledok"
  if (count >= 2 && count <= 4) return `${count} výsledky`
  return `${count} výsledkov`
}
